import { render, staticRenderFns } from "./prestamoFactura.vue?vue&type=template&id=54547b2e"
import script from "./prestamoFactura.vue?vue&type=script&lang=js"
export * from "./prestamoFactura.vue?vue&type=script&lang=js"
import style0 from "./prestamoFactura.vue?vue&type=style&index=0&id=54547b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports